import ScheduleWrapper from '../schedule';

const Schedule = () => <ScheduleWrapper />;

export default Schedule;
